export const USER_INFO_ERROR = "Error getting user info:";
export const ACCESS_TOKEN_ERROR = "Error getting access token:";
export const SOMETHING_WENT_WRONG = "Something went wrong, please try again later";
export const ERROR_FETCH_ALERTS = 'Error fetching "/fetch-alerts":';
